import React from 'react';
import { useSelector } from 'react-redux';
import cN from 'classnames';
import { RootState } from '@Redux/detail/store';
import { LightBox } from '@lion-design/core';
import styles from './styles.module.scss';
import TodayMoreGroupList from './subComponents/TodayMoreGroupList';

interface I_Props {
    open: boolean;
    ToggleLightBox: () => void;
    storyData?: {
        url: string;
    };
}

const GroupAllDetailMore: React.FC<I_Props> = ({ open, ToggleLightBox }) => {
    const { todayMore, GroupInfo } = useSelector((state: RootState) => state.groupReducer);

    return (
        <LightBox
            title="本日其它出發團"
            subTitle="航班時間僅為參考，最終確定之使用航班，以說明會資料為準"
            open={open}
            ToggleLightBox={ToggleLightBox}
            className={cN(styles.container, 'group_detail_more')}
        >
            <TodayMoreGroupList
                todayMoreList={todayMore?.GroupList}
                NormGroupID={todayMore?.NormGroupID}
                triggerLightBox={ToggleLightBox}
                TourSource={GroupInfo.TourSource}
            />
        </LightBox>
    );
};

export default GroupAllDetailMore;
